import React from 'react';

const FeeStructure = () => {
  return (
    <div>
      FeeStructure
      FeeStructure
    </div>
  );
}

export default FeeStructure;
